import { useState } from 'react';

export default function SearchBar({ onSearch, loading }) {
  const [value, setValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const v = value.trim();
    if (!v) return;
    onSearch(v);
  };

  return (
    <form className="search-bar" onSubmit={handleSubmit}>
      <label htmlFor="q">Search for a parcel</label>
      <input
        id="q"
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Address, parcel ID, or &quot;lat, lon&quot;"
        autoComplete="off"
      />
      <button type="submit" disabled={loading || !value.trim()}>
        {loading ? 'Searching…' : 'Find parcel'}
      </button>
      <span className="hint">
        Examples: "1600 Pennsylvania Ave NW, Washington DC" · "39.8283, -98.5795" · "38077717100001"
      </span>
    </form>
  );
}
